import type { FlexingProps } from '../core/flexing';
import type { SpacingProps } from '../core/spacing';

import { memo } from 'react';
import styled from 'styled-components';

import { formatSpacing } from '../core/spacing';
import { formatFlexing } from '../core/flexing';

export const Stack = memo(styled.div<
  SpacingProps &
    FlexingProps & { width?: string; maxWidth?: string; height?: string; position?: string }
>`
  display: flex;
  flex-direction: column;

  ${({ width }) => width && `width: ${width};`}
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ position }) => position && `position: ${position};`}
  ${formatFlexing}
  ${formatSpacing}
`);
